"use client";

import { useEffect } from "react";
import { fetchUserDetails, markAuthStore, saveGAId, selectUserBasicDetails } from "stores/auth/authSlice";
import { useAppDispatch, useAppSelector } from "stores/hooks";
import { getAuthToken, getSoftLoginAuthToken, getUserCookie } from "utils/local-storage";
const UserAuthManagement = () => {
  const dispatch = useAppDispatch();
  const userBasicDetails = useAppSelector(selectUserBasicDetails);
  useEffect(() => {
    const authToken = getAuthToken();
    const softLoginToken = getSoftLoginAuthToken();
    if (!authToken) {
      // assuming that user is NOT logged in
      dispatch(markAuthStore({
        isLoggedIn: false
      })); // logout the user if no AuthToken
    }
    if (softLoginToken) {
      dispatch(markAuthStore({
        softLogin: {
          softLoginType: null,
          isUserSoftLoggedIn: true,
          softLoginPayload: {
            emailId: ""
          }
        }
      }));
    }
    if (getUserCookie() && getAuthToken() || userBasicDetails?.userId) {
      void dispatch(fetchUserDetails()); // need to call when verifyOtpSuccess
      void dispatch(saveGAId()); //save id in database
    }
  }, [dispatch, userBasicDetails?.userId]);
  return null;
};
export default UserAuthManagement;